enum TimeOffType {
  HOLIDAY = 10,
  PERSONAL = 20,
  SICK = 30,
  VACATION = 40,
  OTHER = 50,
}

export default TimeOffType;
